// TipCard — dismissible insight/alert callout with a semantic tone, optional
// icon and CTA. Used for dashboard alerts and inline tips. Controlled dismiss:
// parent removes it on onDismiss (so it can persist the dismissal).
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { CloseIcon } from '../../icons/Icons';
import './tip-card.css';

export function TipCard({ tone = 'info', icon, title, body, cta, onCta, onDismiss, className }) {
  return (
    <div className={cx('tip-card', `tip-card--${tone}`, className)} role="status">
      {icon && <span className="tip-card__icon">{icon}</span>}
      <div className="tip-card__content">
        {title && <p className="tip-card__title">{title}</p>}
        {body && <p className="tip-card__body">{body}</p>}
        {cta && (
          <button type="button" className="tip-card__cta" onClick={onCta}>
            {cta}
          </button>
        )}
      </div>
      {onDismiss && (
        <button type="button" className="tip-card__dismiss" onClick={onDismiss} aria-label="Dismiss">
          <CloseIcon width={14} height={14} />
        </button>
      )}
    </div>
  );
}

TipCard.propTypes = {
  tone: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'purple']),
  icon: PropTypes.node,
  title: PropTypes.node,
  body: PropTypes.node,
  cta: PropTypes.node,
  onCta: PropTypes.func,
  onDismiss: PropTypes.func,
  className: PropTypes.string,
};

export default TipCard;
